// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/time_slot_group.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_planners_v1_resources_daily_workload_level } from "./daily_workload_level_pb.js";
import { file_studyo_today_type_time_slot } from "@buf/studyo_studyo-today-common.bufbuild_es/studyo/today/type/time_slot_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/time_slot_group.proto.
 */
export const file_studyo_today_planners_v1_resources_time_slot_group = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3RpbWVfc2xvdF9ncm91cC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyK6AQoNVGltZVNsb3RHcm91cBIoCgRkYXRlGAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgp0aW1lX3Nsb3RzGAIgAygLMhsuc3R1ZHlvLnRvZGF5LnR5cGUuVGltZVNsb3QSTgoOd29ya2xvYWRfbGV2ZWwYAyABKA4yNi5zdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzLkRhaWx5V29ya2xvYWRMZXZlbEIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_timestamp, file_studyo_today_planners_v1_resources_daily_workload_level, file_studyo_today_type_time_slot]);

/**
 * Describes the message studyo.today.planners.v1.resources.TimeSlotGroup.
 * Use `create(TimeSlotGroupSchema)` to create a new message.
 */
export const TimeSlotGroupSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_time_slot_group, 0);

